export const genderOptions = [
   { value: '1', key: 'Чоловіча' },
   { value: '2', key: 'Жіноча' },
];